<ng-container *ngIf="vm$ | async as vm">
    <p-main-header *ngIf="vm.isLoggedIn"></p-main-header>
    <main>
        <p-splitter direction="horizontal">
            <!-- While a Seemore canvas is open the page is hidden behind it (not destroyed) and the chat panel takes the full width -->
            <p-splitter-area class="p-splitter-area--scroll-x" [size]="70" [minSize]="30" [visible]="(isCanvasOpen$ | async) !== true">
                <p-loading></p-loading>
                <div class="fill-parent flex-column" *ngIf="vm.showNewApp && vm.isLoggedIn">
                    <router-outlet></router-outlet>
                    <router-outlet name="dialog" #dialogOutlet></router-outlet>
                </div>
                <p-hybrid-iframe></p-hybrid-iframe>
                <upload-progress></upload-progress>
            </p-splitter-area>
            <p-splitter-area [size]="30" [minSize]="20" [visible]="!!(isPanelOpen$ | async)">
                <p-ai-chat-panel *ngIf="vm.isLoggedIn"></p-ai-chat-panel>
            </p-splitter-area>
        </p-splitter>
    </main>
</ng-container>
